var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClock = function SvgIconClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.87 16.82 1.12-1.12-3.97-4V6.68h-1.5v5.62zM12.19 22a10.14 10.14 0 0 1-9.21-6.13A9.7 9.7 0 0 1 2.19 12a10.14 10.14 0 0 1 6.13-9.21A9.7 9.7 0 0 1 12.19 2a10.14 10.14 0 0 1 9.21 6.13c.53 1.21.8 2.5.8 3.87s-.27 2.66-.8 3.88a10.14 10.14 0 0 1-5.33 5.33c-1.22.53-2.51.79-3.88.79m0-1.5c2.33 0 4.33-.83 6-2.5a8.18 8.18 0 0 0 2.5-6c0-2.33-.83-4.33-2.5-6a8.18 8.18 0 0 0-6-2.5c-2.33 0-4.33.83-6 2.5a8.18 8.18 0 0 0-2.5 6c0 2.33.83 4.33 2.5 6a8.18 8.18 0 0 0 6 2.5"
  })));
};
export default SvgIconClock;